(() => {
  const root = document.getElementById('rh-cloud-welcome');
  if (!root || root.dataset.mounted === 'true') return;
  root.dataset.mounted = 'true';
  const dialog = root.querySelector('dialog');
  const trigger = root.querySelector('[data-cloud-open]');
  const picker = root.querySelector('[data-cloud-picker]');
  const capture = root.querySelector('[data-cloud-capture]');
  const sent = root.querySelector('[data-cloud-sent]');
  const form = root.querySelector('#rh-cloud-form');
  const email = root.querySelector('#rh-cloud-email');
  const status = root.querySelector('[data-cloud-form-status]');
  const storageKey = 'rh_cloud_email_v1';
  const timerKey = storageKey + '_elapsed';
  const pendingKey = storageKey + '_pending';
  let pending = false;
  try { pending = sessionStorage.getItem(pendingKey) === '1'; } catch {}
  const week = 7 * 24 * 60 * 60 * 1000;
  let saved = {};
  let elapsed = 0;
  let activeSince = 0;
  let timer;
  let opener;
  let previousOverflow = '';
  try { saved = JSON.parse(localStorage.getItem(storageKey) || '{}') || {}; } catch {}
  try { elapsed = Math.min(10000, Math.max(0, Number(sessionStorage.getItem(timerKey)) || 0)); } catch {}
  if (!['Dreamer', 'Lounger', 'Nester'].includes(saved.choice)) saved.choice = null;
  let phase = saved.completed ? 'sent' : saved.choice ? 'email' : 'picker';
  const posted = pending && status.dataset.posted === 'true';
  const formErrors = pending && status.dataset.hasErrors === 'true';
  if (posted) { saved.completed = true; phase = 'sent'; }
  if (posted || formErrors) { try { sessionStorage.removeItem(pendingKey); } catch {} }
  function persist() {
    try { localStorage.setItem(storageKey, JSON.stringify(saved)); } catch {}
  }
  function render() {
    picker.hidden = phase !== 'picker';
    capture.hidden = phase !== 'email';
    sent.hidden = phase !== 'sent';
    root.querySelectorAll('[data-cloud-step]').forEach(step => { step.hidden = step.dataset.cloudStep !== phase; });
    const index = ['Dreamer', 'Lounger', 'Nester'].indexOf(saved.choice);
    root.querySelector('[data-cloud-photo]').style.setProperty('--pc-x', Math.max(0, index) * 50 + '%');
    trigger.querySelector('span').textContent = saved.completed ? root.dataset.savedLabel : root.dataset.waitingLabel;
  }
  function stopClock() {
    if (activeSince) elapsed = Math.min(10000, elapsed + performance.now() - activeSince);
    activeSince = 0;
    clearTimeout(timer);
    try { sessionStorage.setItem(timerKey, String(elapsed)); } catch {}
  }
  function open() {
    if (dialog.open) return;
    stopClock();
    opener = document.activeElement;
    render();
    trigger.hidden = true;
    previousOverflow = document.body.style.overflow;
    dialog.showModal();
    document.body.style.overflow = 'hidden';
    saved.dismissedUntil = Date.now() + week;
    persist();
  }
  function close() {
    if (dialog.open) dialog.close();
  }
  dialog.addEventListener('close', () => {
    document.body.style.overflow = previousOverflow;
    trigger.hidden = false;
    saved.dismissedUntil = Date.now() + week;
    persist();
    if (opener instanceof HTMLElement && opener.isConnected) opener.focus();
  });
  root.querySelectorAll('[data-cloud-close]').forEach(button => button.addEventListener('click', close));
  dialog.addEventListener('click', event => { if (event.target === dialog && (event.clientX < dialog.getBoundingClientRect().left || event.clientX > dialog.getBoundingClientRect().right || event.clientY < dialog.getBoundingClientRect().top || event.clientY > dialog.getBoundingClientRect().bottom)) close(); });
  root.querySelectorAll('[data-cloud-choice]').forEach(button => button.addEventListener('click', () => {
    saved.choice = button.dataset.cloudChoice;
    phase = 'email';
    persist();
    render();
    email.focus();
  }));
  trigger.addEventListener('click', open);
  document.addEventListener('click', event => {
    const target = event.target.closest('[data-open-offer]');
    if (target) { event.preventDefault(); open(); }
  });
  form.addEventListener('submit', event => {
    email.value = email.value.trim();
    if (!email.reportValidity()) {
      event.preventDefault();
      return;
    }
    root.querySelector('[data-cloud-tags]').value = 'newsletter,rh-cloud-welcome' + (saved.choice ? ',rh-cloud-' + saved.choice.toLowerCase() : '');
    try { sessionStorage.setItem(pendingKey, '1'); } catch {}
    // Shopify may mount a verification challenge outside the dialog. Release
    // the modal top layer so that challenge remains visible and interactive.
    close();
  }, { capture: true });
  const copyButton = root.querySelector('[data-cloud-copy]');
  const code = root.querySelector('[data-cloud-code]');
  const copyFeedback = root.querySelector('[data-cloud-copy-feedback]');
  if (copyButton && code && copyFeedback) {
    copyButton.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(code.textContent.trim());
        copyButton.textContent = copyButton.dataset.copiedLabel;
        copyFeedback.textContent = copyButton.dataset.copiedLabel;
      } catch {
        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(code);
        code.focus();
        selection?.removeAllRanges();
        selection?.addRange(range);
        copyFeedback.textContent = copyButton.dataset.copyFallback;
      }
    });
  }
  root.querySelector('[data-cloud-shop]').addEventListener('click', close);
  // Automatic welcome interruptions are paused; the offer stays available on request.
  const autoOpen = false;
  function runClock() {
    if (!autoOpen) return;
    if (document.hidden || dialog.open || saved.completed || saved.dismissedUntil > Date.now()) return;
    activeSince = performance.now();
    timer = setTimeout(() => {
      stopClock();
      const otherDialog = document.querySelector('dialog[open], [aria-modal="true"]:not([hidden])');
      if (otherDialog) { timer = setTimeout(runClock, 750); return; }
      open();
    }, Math.max(0, 10000 - elapsed));
  }
  document.addEventListener('visibilitychange', () => { stopClock(); if (!document.hidden) runClock(); });
  window.addEventListener('pagehide', stopClock);
  window.addEventListener('storage', event => {
    if (event.key !== storageKey) return;
    try { const next = JSON.parse(event.newValue || '{}'); if (next && typeof next === 'object') { saved = next; render(); stopClock(); } } catch {}
  });
  render();
  trigger.hidden = false;
  if (posted || formErrors) { persist(); open(); if (formErrors) { phase = 'email'; render(); email.focus(); } }
  else if (!window.Shopify?.designMode) runClock();
})();

